const NAME = "BILLING";
export const INVOICENUMBER = `${NAME}/INVOICENUMBER`;

export const GETCURRENTBILL = `${NAME}/GETCURRENTBILL`;
export const GETCURRENTBILL_SUCCESS = `${NAME}/GETCURRENTBILL_SUCCESS`;
export const GETCURRENTBILL_FAILURE = `${NAME}/GETCURRENTBILL_FAILURE`;

export const GETCONTRACTACCOUNT = `${NAME}/GETCONTRACTACCOUNT`;
export const GETCONTRACTACCOUNT_SUCCESS = `${NAME}/GETCONTRACTACCOUNT_SUCCESS`;
export const GETCONTRACTACCOUNT_FAILURE = `${NAME}/GETCONTRACTACCOUNT_FAILURE`;

export const GETCONTRACTID = `${NAME}/GETCONTRACTID`;

export const GETQUICKBILL = `${NAME}/GETQUICKBILL`;
export const GETQUICKBILL_SUCCESS = `${NAME}/GETQUICKBILL_SUCCESS`;
export const GETQUICKBILL_FAILURE = `${NAME}/GETQUICKBILL_FAILURE`;

export const SET_CONTRACT_ACCOUNT = `${NAME}/SET_CONTRACT_ACCOUNT`;
export const RESET_QUICK_BILL = "${NAME}/RESET_QUICK_BILL";
export const RESET = `${NAME}/RESET`;

export const SET_CONTRACT_ACCOUNTS = `${NAME}/SET_CONTRACT_ACCOUNTS`;
export const SETCONTRACTACCOUNTCALL_RESPONSE = `${NAME}/SETCONTRACTACCOUNTCALL_RESPONSE`;

export const SETFOOTERENABLED = `${NAME}/SETFOOTERENABLED`;

export const getInvoiceNumber = (invoiceNumber) => {
  return {
    type: INVOICENUMBER,
    invoiceNumber,
  };
};

export const getCurrentBill = (billId, callback) => {
  return {
    type: GETCURRENTBILL,
    billId,
    callback,
  };
};

export const getCurrentBillSuccess = (data) => {
  return {
    type: GETCURRENTBILL_SUCCESS,
    data,
  };
};

export const getCurrentBillFailure = (error) => {
  return {
    type: GETCURRENTBILL_FAILURE,
    error,
  };
};

export const getContractAccount = (contractid) => {
  return {
    type: GETCONTRACTACCOUNT,
    contractid,
  };
};

export const getContractAccountSuccess = (data) => {
  return {
    type: GETCONTRACTACCOUNT_SUCCESS,
    data,
  };
};

export const getContractAccountFailure = (error) => {
  return {
    type: GETCONTRACTACCOUNT_FAILURE,
    error,
  };
};

export const getContractId = (contractId) => {
  return {
    type: GETCONTRACTID,
    contractId,
  };
};
export const getQuickBill = (contractAccountNumber, callback) => {
  //,priorCharges,unappliedPaymentsAndAdjustments,totalOutstandingCharges,totalCurrentCharges,monthlyRecurringCharges,professionalServices,equipmentCharges,taxesAndSurcharges,dueDate,invoiceNumber,totalAmountDue,callback) => {
  return {
    type: GETQUICKBILL,
    contractAccountNumber, //,priorCharges,unappliedPaymentsAndAdjustments,totalOutstandingCharges,totalCurrentCharges,monthlyRecurringCharges,professionalServices,equipmentCharges,taxesAndSurcharges,dueDate,invoiceNumber,totalAmountDue,
    callback,
  };
};
export const getQuickBillSuccess = (data, currencySymbol) => {
  return {
    type: GETQUICKBILL_SUCCESS,
    data,
    currencySymbol,
  };
};

export const getQuickBillFailure = (error) => {
  return {
    type: GETQUICKBILL_FAILURE,
    error,
  };
};

export const setContractAccount = (data) => {
  return {
    type: SET_CONTRACT_ACCOUNT,
    data,
  };
};

export const resetQuickBill = () => {
  return {
    type: RESET_QUICK_BILL,
  };
};

export const reset = () => {
  return {
    type: RESET,
  };
};

export const setContractAccounts = (data) => {
  return {
    type: SET_CONTRACT_ACCOUNTS,
    data,
  };
};
export const setContractAccountCallResponse = (data) => {
  return {
    type: SETCONTRACTACCOUNTCALL_RESPONSE,
    data,
  };
};
export const setFooterEnabled = (data) => {
  return {
    type: SETFOOTERENABLED,
    data,
  };
};
